import React, { useEffect, useState, useRef } from 'react';
import { FaArrowLeft, FaArrowRight, FaBalanceScale, FaBook, FaBookOpen, FaCalendar, FaCashRegister, FaChartArea, FaChartBar, FaFileAlt, FaFileExcel, FaFilePdf, FaFileWord, FaList, FaPiggyBank, FaPrint, FaDownload, FaSearch, FaRobot, FaTimes } from 'react-icons/fa';
import Payments from './payments';
import { SiPivotaltracker } from "react-icons/si";
import TrialBalance from './trialBalance';
import CashBook from './cash';
import DetailedIncomeStatement from './income';
import { formatDate, handlePrint, rootUrl } from '../../../helpers';
import axios from 'axios';
import { useAuth } from '../../../context/auth-context';
import BalanceSheet from './balance';
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
import Ipsas from './ipsas';
import BankReconciliation from './bankrec';
import Receipts from './receipts';
import Projects from './projects';
import { MdOutlinePayments } from "react-icons/md";
import { GrProjects } from "react-icons/gr";
import { BiCategory, BiMath } from "react-icons/bi";
import * as XLSX from 'xlsx';
import { toast } from 'react-toastify';
import { FaBookAtlas, FaBookBookmark, FaBookJournalWhills, FaListCheck } from 'react-icons/fa6';
import BillReport from './bills';
import SummaryCash from './summaryCash';
import Department from './department';
import Pivot from './pivot';
import Fiscal from './fiscal';
import AiAssistantReport from './aiAssistant';
import PvStatus from './pvStatus';

export default function Reports() {
  const [activeTab, setActiveTab] = useState('randc');
  const [activeSection, setActiveSection] = useState('reports1');
  const [rdata, setData] = useState([]);
  const [userReportRoles, setUserReportRoles] = useState([]);
  const [triggerFetch, setTriggerFetch] = useState(0);
  const auth = useAuth();
  const componentRef = useRef();

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [showAiAssistant, setShowAiAssistant] = useState(false);

  const fetchData = async () => {
    try {

      if(activeTab === 'tb' || activeTab === 'income' || activeTab ==='balance'){
      const response = await axios.get(rootUrl(`/trialBalance/${auth.user.cid}~${startDate}~${endDate}`));
      setData(response.data);
    }
      setTriggerFetch(prev => prev + 1);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const fetchUserReportRoles = async () => {
    try {
      const response = await axios.get(rootUrl(`/getUserReportRolesWithDetails/${auth.user.id}`));
      if (response.status === 200) {
        setUserReportRoles(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching user report roles:", error);
    }
  };

  useEffect(() => {   
    fetchUserReportRoles();
  }, []);

  // Remove the automatic data fetching useEffect

  // Check if user has access to a specific report
  const hasReportAccess = (reportName) => {
    if (reportName === 'pvstatus') {
      return userReportRoles.some((role) => ['pvstatus', 'cash', 'randc'].includes(role.name));
    }
    return userReportRoles.some(role => role.name === reportName);
  };

  // Filter reports based on user's roles
  const getAvailableReports = () => {
    const allReports = [
      { name: 'randc', label: 'Receipts/Payments', icon: <MdOutlinePayments className='mr-1'/>, section: 'reports1' },
      { name: 'pivot', label: 'Pivot', icon: <SiPivotaltracker className='mr-1'/>, section: 'reports1' },
      { name: 'tb', label: 'Trial Balance', icon: <FaBalanceScale className='mr-1'/>, section: 'reports1' },
      { name: 'cash', label: 'Ledgers & Cashbooks', icon: <FaBookBookmark className='mr-1'/>, section: 'reports1' },
      { name: 'income', label: 'Income Statement', icon: <FaFileAlt className='mr-1'/>, section: 'reports1' },
      { name: 'fiscal', label: 'Fiscal Report', icon: <FaChartBar className='mr-1'/>, section: 'reports1' },
      { name: 'balance', label: 'Financial Position', icon: <FaBalanceScale className='mr-1'/>, section: 'reports2' },
      { name: 'bills', label: 'Bills', icon: <FaListCheck className='mr-1'/>, section: 'reports2' },
      { name: 'projects', label: 'Projects', icon: <GrProjects className='mr-1'/>, section: 'reports2' },
      { name: 'department', label: 'Department', icon: <BiCategory className='mr-1'/>, section: 'reports2' },
      { name: 'pvstatus', label: 'PV Approval Status', icon: <FaListCheck className='mr-1'/>, section: 'reports2' },
      { name: 'ipsas', label: 'Ipsas', icon: <FaFileWord className='mr-1'/>, section: 'reports2' }
    ];

    return allReports.filter(report => hasReportAccess(report.name));
  };

  const availableReports = getAvailableReports();

  // Set default active tab to first available report
  useEffect(() => {
    if (availableReports.length > 0 && !availableReports.find(r => r.name === activeTab)) {
      setActiveTab(availableReports[0].name);
    }
  }, [availableReports]);

  function handleExportToPDF() {
    const input = componentRef.current;
  
    html2canvas(input, { scrollY: -window.scrollY }).then((canvas) => {
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF('p', 'mm', 'a4');
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
  
      // Calculate the height of the content in the PDF
      const canvasWidth = canvas.width;
      const canvasHeight = canvas.height;
      const imgHeight = (canvasHeight * pdfWidth) / canvasWidth;
      let heightLeft = imgHeight;
  
      let position = 0;
  
      // Add the first page
      pdf.addImage(imgData, 'PNG', 0, position, pdfWidth, imgHeight);
      heightLeft -= pdfHeight;
  
      // Add more pages if needed
      while (heightLeft > 0) {
        position -= pdfHeight;
        pdf.addPage();
        pdf.addImage(imgData, 'PNG', 0, position, pdfWidth, imgHeight);
        heightLeft -= pdfHeight;
      }
  
      pdf.save(`${activeTab}.pdf`);
    });
  }

  
  

  function handleExportToExcel() {
    const input = componentRef.current;
  
    if (!input) return;
  
    // Extract table or structured data from the ref
    const rows = Array.from(input.querySelectorAll('tr')).map((row) => {
      return Array.from(row.querySelectorAll('th, td')).map((cell) => cell.textContent);
    });
  
    // Create a worksheet and workbook
    const worksheet = XLSX.utils.aoa_to_sheet(rows);
    const workbook = XLSX.utils.book_new();
  
    // Append the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
  
    // Export the workbook as an Excel file
    XLSX.writeFile(workbook, `${activeTab}.xlsx`);
  }
  
  const renderContent = () => {
    switch (activeTab) {
      case 'randc':
        return <TabbedComponent startDate={startDate} endDate={endDate} rdata={rdata} triggerFetch={triggerFetch} />;
        case 'pivot':
      return <Pivot startDate={startDate} endDate={endDate} triggerFetch={triggerFetch} />;
      case 'tb':
        return <TrialBalance rdata={rdata} startDate={startDate} endDate={endDate} />;
      case 'cash':
        return <CashComponent startDate={startDate} endDate={endDate} triggerFetch={triggerFetch} />;
      case 'income':
        return <DetailedIncomeStatement rdata={rdata} startDate={startDate} endDate={endDate} />;
      case 'fiscal':
        return <Fiscal startDate={startDate} endDate={endDate} triggerFetch={triggerFetch} />;
      case 'balance':
        return <BalanceSheet rdata={rdata} startDate={startDate} endDate={endDate} />;
        case 'bills':
        return <BillReport startDate={startDate} endDate={endDate} triggerFetch={triggerFetch} />;
      // case 'bank':
      //   return <BankReconciliation startDate={startDate} endDate={endDate} />;
      case 'ipsas':
        return <Ipsas rdata={rdata} startDate={startDate} endDate={endDate} />;
      case 'department':
          return <Department startDate={startDate} endDate={endDate} triggerFetch={triggerFetch} />; 
      case 'projects':
        return <Projects startDate={startDate} endDate={endDate} triggerFetch={triggerFetch} />;
      case 'pvstatus':
        return <PvStatus startDate={startDate} endDate={endDate} triggerFetch={triggerFetch} />;
      default:
        return <div>Welcome to Reports</div>;
    }
    
  };

  // If user has no report access, show message
  if (availableReports.length === 0) {
    return (
      <div className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100">
        <div className="flex flex-col justify-center items-center h-64">
          <div className="p-4 bg-gray-100 rounded-full mb-4">
            <FaChartBar className="text-gray-400 text-5xl" />
          </div>
          <h2 className="text-xl font-semibold text-gray-700 mb-2">No Report Access</h2>
          <p className="text-gray-600 text-center max-w-md">You don't have access to any reports. Please contact your administrator.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="bg-gradient-to-r from-blue-950 to-blue-800 rounded-2xl p-6 text-white shadow-lg">
        <div className="flex items-center justify-between gap-4">
          <div className="flex items-center gap-4">
            <div className="bg-white/20 rounded-xl p-3">
              <FaChartBar className="text-2xl" />
            </div>
            <div>
              <h1 className="text-2xl md:text-3xl font-bold">Reports</h1>
              <p className="text-blue-100 text-sm mt-1">
                Generate and export financial reports
              </p>
            </div>
            </div>
          {/* Section Navigation */}
          <div className="flex items-center gap-2 bg-white/20 rounded-lg p-1">
            <button
              onClick={() => setActiveSection('reports1')}
              className={`px-4 py-2 rounded-md transition-all flex items-center gap-2 font-medium text-sm ${
                activeSection === 'reports1'
                  ? 'bg-white text-blue-950 shadow-sm'
                  : 'text-white/80 hover:bg-white/10'
              }`}
            >
              <FaArrowLeft className="text-xs" />
              Section 1
            </button>
            <button
              onClick={() => setActiveSection('reports2')}
              className={`px-4 py-2 rounded-md transition-all flex items-center gap-2 font-medium text-sm ${
                activeSection === 'reports2'
                  ? 'bg-white text-blue-950 shadow-sm'
                  : 'text-white/80 hover:bg-white/10'
              }`}
            >
              Section 2
              <FaArrowRight className="text-xs" />
            </button>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="w-full bg-white rounded-2xl p-4 md:p-6 shadow-sm border border-gray-100">

      {/* Tabs for Reports 1 */}
      {activeSection === 'reports1' && (
        <nav className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-2 mb-6 bg-gray-50 p-2 rounded-xl border border-gray-200">
          {availableReports.filter(report => report.section === 'reports1').map((report) => (
            <button
              key={report.name}
              onClick={() => setActiveTab(report.name)}
              className={`cursor-pointer py-3 px-3 rounded-lg font-medium text-sm transition-all flex items-center justify-center gap-2 ${
                activeTab === report.name 
                  ? 'bg-blue-950 text-white shadow-md transform scale-105' 
                  : 'bg-white text-gray-700 hover:bg-gray-100 border border-gray-200'
              }`}
            >
              <span className={activeTab === report.name ? 'text-white' : 'text-gray-600'}>
                {report.icon}
              </span>
              <span className="hidden sm:inline">{report.label}</span>
            </button>
          ))}
        </nav>
      )}

      {/* Tabs for Reports 2 */}
      {activeSection === 'reports2' && (
        <nav className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-2 mb-6 bg-gray-50 p-2 rounded-xl border border-gray-200">
          {availableReports.filter(report => report.section === 'reports2').map((report) => (
            <button
              key={report.name}
              onClick={() => setActiveTab(report.name)}
              className={`cursor-pointer py-3 px-3 rounded-lg font-medium text-sm transition-all flex items-center justify-center gap-2 ${
                activeTab === report.name 
                  ? 'bg-blue-950 text-white shadow-md transform scale-105' 
                  : 'bg-white text-gray-700 hover:bg-gray-100 border border-gray-200'
              }`}
            >
              <span className={activeTab === report.name ? 'text-white' : 'text-gray-600'}>
                {report.icon}
              </span>
              <span className="hidden sm:inline">{report.label}</span>
            </button>
          ))}
        </nav>
      )}

      {/* Date Filters and Actions */}
      <div className='flex flex-col md:flex-row md:justify-between md:items-center gap-4 mb-6 p-4 bg-gray-50 rounded-xl border border-gray-200'>
        <div className='flex flex-col sm:flex-row items-start sm:items-center gap-3 flex-1'>
          <div className="relative flex-1 sm:flex-initial">
            <FaCalendar className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none" />
            <label className="block text-xs font-medium text-gray-700 mb-1 sm:hidden">From Date</label>
            <input
              type="date"
              id="from"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              className="pl-10 pr-4 py-2.5 w-full sm:w-[200px] border border-gray-300 rounded-lg text-gray-700 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white"
              placeholder="From"
            />
          </div>
          <div className="relative flex-1 sm:flex-initial">
            <FaCalendar className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none" />
            <label className="block text-xs font-medium text-gray-700 mb-1 sm:hidden">To Date</label>
            <input
              type="date"
              id="to"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              className="pl-10 pr-4 py-2.5 w-full sm:w-[200px] border border-gray-300 rounded-lg text-gray-700 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white"
              placeholder="To"
            />
          </div>
          <button
            onClick={() => {
              if (startDate === "" || endDate === "") {
                toast.info("Please select both start and end dates");
                return;
              }
              fetchData();
            }}
            className="px-5 py-2.5 bg-blue-950 text-white rounded-lg hover:bg-blue-900 transition-colors font-medium text-sm flex items-center gap-2 shadow-sm"
          >
            <FaSearch className="text-xs" />
            Fetch Data
          </button>
        </div>

        {/* Export Actions */}
        <div className="flex items-center gap-2 flex-wrap">
          <button
            onClick={handleExportToPDF}
            className="px-4 py-2.5 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors font-medium text-sm flex items-center gap-2 shadow-sm"
            title="Export to PDF"
          >
            <FaFilePdf />
            <span className="hidden sm:inline">PDF</span>
          </button>
          <button
            onClick={() => handlePrint(componentRef)}
            className="px-4 py-2.5 bg-gray-700 text-white rounded-lg hover:bg-gray-800 transition-colors font-medium text-sm flex items-center gap-2 shadow-sm"
            title="Print"
          >
            <FaPrint />
            <span className="hidden sm:inline">Print</span>
          </button>
          <button
            onClick={handleExportToExcel}
            className="px-4 py-2.5 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors font-medium text-sm flex items-center gap-2 shadow-sm"
            title="Export to Excel"
          >
            <FaFileExcel />
            <span className="hidden sm:inline">Excel</span>
          </button>
        </div>
      </div>

      

      

        {/* Content Section */}
        <div className="mt-6" ref={componentRef}>
          {(startDate === "" || endDate === "") ? (
            <div className="flex flex-col justify-center items-center py-16 bg-gray-50 rounded-xl border border-gray-200">
              <div className="p-4 bg-blue-100 rounded-full mb-4">
                <FaCalendar className="text-blue-600 text-5xl" />
              </div>
              <h3 className="text-lg font-semibold text-gray-700 mb-2">Select Date Range</h3>
              <p className="text-gray-600 text-center max-w-md">Please select both start and end dates above to view your report</p>
            </div>
          ) : (
            <div className="bg-white rounded-xl border border-gray-200 p-4 md:p-6">
              {renderContent()}
            </div>
          )}
        </div>
      </div>

      {/* Floating AI Assistant Button */}
      <button
        type="button"
        onClick={() => setShowAiAssistant(true)}
        className="fixed bottom-6 right-6 z-40 bg-blue-950 hover:bg-blue-900 text-white rounded-full shadow-xl px-4 py-3 flex items-center gap-2 transition-colors"
      >
        <FaRobot />
        <span className="text-sm font-medium hidden sm:inline">AI Assistant</span>
      </button>

      {/* AI Assistant Slide-over */}
      {showAiAssistant && (
        <div className="fixed inset-0 z-50 flex justify-end">
          <div
            className="absolute inset-0 bg-black/30"
            onClick={() => setShowAiAssistant(false)}
          />
          <div className="relative h-full w-full sm:w-[900px] bg-white shadow-2xl border-l border-gray-200 overflow-auto">
            <div className="sticky top-0 z-10 bg-white border-b border-gray-200 px-4 py-3 flex items-center justify-between">
              <h3 className="font-semibold text-gray-800">AI Assistant</h3>
              <button
                type="button"
                onClick={() => setShowAiAssistant(false)}
                className="p-2 rounded-lg hover:bg-gray-100 text-gray-600"
              >
                <FaTimes />
              </button>
            </div>
            <div className="p-4">
              <AiAssistantReport />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const TabbedComponent = ({startDate, endDate, rdata, triggerFetch}) => {
  const [activeTab, setActiveTab] = useState("payments");
  return (
    <div>
      {/* Tab Navigation */}
      <div className="flex justify-center gap-3 mb-6 bg-gray-50 p-2 rounded-xl border border-gray-200">
        <button
          className={`px-6 py-3 rounded-lg font-medium text-sm transition-all flex items-center gap-2 ${
            activeTab === "payments" 
              ? "bg-blue-950 text-white shadow-md" 
              : "bg-white text-gray-700 hover:bg-gray-100 border border-gray-200"
          }`}
          onClick={() => setActiveTab("payments")}
        >
          <FaChartArea className={activeTab === "payments" ? "text-white" : "text-gray-600"} />
          COA
        </button>
        <button
          className={`px-6 py-3 rounded-lg font-medium text-sm transition-all flex items-center gap-2 ${
            activeTab === "receipts" 
              ? "bg-blue-950 text-white shadow-md" 
              : "bg-white text-gray-700 hover:bg-gray-100 border border-gray-200"
          }`}
          onClick={() => setActiveTab("receipts")}
        >
          <FaChartBar className={activeTab === "receipts" ? "text-white" : "text-gray-600"} />
          Program
        </button>
      </div>

      {/* Tab Content */}
      <div className="tab-content">
        {activeTab === "payments" && <Payments startDate={startDate} endDate={endDate} triggerFetch={triggerFetch} />}
        {activeTab === "receipts" && <Receipts startDate={startDate} endDate={endDate} triggerFetch={triggerFetch} />}
      </div>
    </div>
  );
};

const CashComponent = ({startDate, endDate, triggerFetch}) => {
  const [activeTab, setActiveTab] = useState("detailed");
  return (
    <div>
      {/* Tab Navigation */}
      <div className="flex justify-center gap-3 mb-6 bg-gray-50 p-2 rounded-xl border border-gray-200">
        <button
          className={`px-6 py-3 rounded-lg font-medium text-sm transition-all flex items-center gap-2 ${
            activeTab === "detailed" 
              ? "bg-blue-950 text-white shadow-md" 
              : "bg-white text-gray-700 hover:bg-gray-100 border border-gray-200"
          }`}
          onClick={() => setActiveTab("detailed")}
        >
          <FaBookJournalWhills className={activeTab === "detailed" ? "text-white" : "text-gray-600"} />
          Ledgers
        </button>
        <button
          className={`px-6 py-3 rounded-lg font-medium text-sm transition-all flex items-center gap-2 ${
            activeTab === "summary" 
              ? "bg-blue-950 text-white shadow-md" 
              : "bg-white text-gray-700 hover:bg-gray-100 border border-gray-200"
          }`}
          onClick={() => setActiveTab("summary")}
        >
          <FaBook className={activeTab === "summary" ? "text-white" : "text-gray-600"} />
          Cashbooks
        </button>
      </div>

      {/* Tab Content */}
      <div className="tab-content">
        {activeTab === "detailed" && <CashBook startDate={startDate} endDate={endDate} triggerFetch={triggerFetch} />}
        {activeTab === "summary" && <SummaryCash startDate={startDate} endDate={endDate} triggerFetch={triggerFetch} />}
      </div>
    </div>
  );
};

